import SectionHeading from "./SectionHeading";
import { recommendList } from "@/mocks/catalog";

export default function Recommend() {
  return (
    <section id="recommend" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-8">
        <SectionHeading
          eyebrow="推荐方向"
          title="不按排名，按你的浏览场景来推荐"
          desc="与其给一份绝对榜单，不如按场景给出方向。下面每一条都写明了适用人群与推荐理由，你可以直接对号入座。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {recommendList.map((item, index) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 font-heading text-sm font-semibold text-primary-700">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="flex flex-wrap justify-end gap-1.5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold leading-snug text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 flex items-center gap-1.5 text-xs text-primary-700">
                <i className="ri-user-heart-line text-sm"></i>
                适合：{item.audience}
              </p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.reason}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}